import axios from 'axios';
import Auth from '../lib/auth';
import utilsLib from './utils.lib';
import { addNotification } from './notifications';
import {saveFile} from "../lib/content-lib";

export const GET_RECEIPTS_REQUEST = 'GET_RECEIPTS_REQUEST';
export const GET_RECEIPTS_SUCCESS = 'GET_RECEIPTS_SUCCESS';
export const GET_RECEIPTS_ERROR = 'GET_RECEIPTS_ERROR';

export const GET_RECEIPT_REQUEST = 'GET_RECEIPT_REQUEST';
export const GET_RECEIPT_SUCCESS = 'GET_RECEIPT_SUCCESS';
export const GET_RECEIPT_ERROR = 'GET_RECEIPT_ERROR';

export const CREATE_RECEIPT_REQUEST = 'CREATE_RECEIPT_REQUEST';
export const CREATE_RECEIPT_SUCCESS = 'CREATE_RECEIPT_SUCCESS';
export const CREATE_RECEIPT_ERROR = 'CREATE_RECEIPT_ERROR';

export const UPDATE_RECEIPT_REQUEST = 'UPDATE_RECEIPT_REQUEST';
export const UPDATE_RECEIPT_SUCCESS = 'UPDATE_RECEIPT_SUCCESS';
export const UPDATE_RECEIPT_ERROR = 'UPDATE_RECEIPT_ERROR';

export const UPLOAD_RECEIPT_FILES_REQUEST = 'UPLOAD_RECEIPT_FILES_REQUEST';
export const UPLOAD_RECEIPT_FILES_PROGRESS = 'UPLOAD_RECEIPT_FILES_PROGRESS';
export const UPLOAD_RECEIPT_FILES_SUCCESS = 'UPLOAD_RECEIPT_FILES_SUCCESS';
export const UPLOAD_RECEIPT_FILES_ERROR = 'UPLOAD_RECEIPT_FILES_ERROR';

export const DELETE_RECEIPT_FILE_REQUEST = 'DELETE_RECEIPT_FILE_REQUEST';
export const DELETE_RECEIPT_FILE_SUCCESS = 'DELETE_RECEIPT_FILE_SUCCESS';
export const DELETE_RECEIPT_FILE_ERROR = 'DELETE_RECEIPT_FILE_ERROR';

export const DELETE_RECEIPT_REQUEST = 'DELETE_RECEIPT_REQUEST';
export const DELETE_RECEIPT_SUCCESS = 'DELETE_RECEIPT_SUCCESS';
export const DELETE_RECEIPT_ERROR = 'DELETE_RECEIPT_ERROR';

export const CLEAN_RECEIPTS = 'CLEAN_RECEIPTS';

// Get receipts
export function getReceipts(query) {
    return async (dispatch) => {
        try {
            dispatch(getReceiptsRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/receipts/query', query, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getReceiptsSuccess, getReceiptsError));
        } catch (err) {
            dispatch(utilsLib.response(err, getReceiptsError));
        }
    };
}
function getReceiptsRequest() {
    return {
        type: GET_RECEIPTS_REQUEST,
        isFetching: true
    };
}
function getReceiptsSuccess (payload) {
    return {
        type: GET_RECEIPTS_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getReceiptsError(errorMessage) {
    return {
        type: GET_RECEIPTS_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Get receipt
export function getReceipt(receiptId) {

    return async (dispatch) => {
        try {
            dispatch(getReceiptRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/receipts/${receiptId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getReceiptSuccess, getReceiptError));
        } catch (err) {
            dispatch(utilsLib.response(err, getReceiptError));
        }
    };
}
function getReceiptRequest() {
    return {
        type: GET_RECEIPT_REQUEST,
        isFetching: true
    };
}
function getReceiptSuccess (payload) {
    return {
        type: GET_RECEIPT_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getReceiptError(errorMessage) {
    return {
        type: GET_RECEIPT_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Create receipt
export function createReceipt(receipt, options) {
    return async (dispatch) => {
        try {
            dispatch(createReceiptRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/receipts', {receipt, options}, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, createReceiptSuccess, createReceiptError));
        } catch (err) {
            dispatch(utilsLib.response(err, createReceiptError));
        }
    };
}
function createReceiptRequest() {
    return {
        type: CREATE_RECEIPT_REQUEST,
        isFetching: true
    };
}
function createReceiptSuccess (payload) {
    return dispatch => {
        // Create notification for create receipt success
        dispatch(addNotification({
            message: 'Albaran de entrada añadido correctamente',
            color: 'green',
            icon: 'tick'
        }));

        dispatch({
            type: CREATE_RECEIPT_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function createReceiptError(errorMessage) {
    return dispatch => {
        // Create notification for create receipt error
        dispatch(addNotification({
            message: 'Error al añadir el albaran de entrada',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CREATE_RECEIPT_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Update receipt
export function updateReceipt(receiptId, receipt = {}) {
    return async (dispatch) => {
        try {
            dispatch(updateReceiptRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/receipts/${receiptId}`, receipt, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, updateReceiptSuccess, updateReceiptError));
        } catch (err) {
            dispatch(utilsLib.response(err, updateReceiptError));
        }
    };
}
function updateReceiptRequest() {
    return {
        type: UPDATE_RECEIPT_REQUEST,
        isFetching: true
    };
}
function updateReceiptSuccess (payload) {
    return dispatch => {
        // Create notification for update receipt success
        dispatch(addNotification({
            message: 'Albaran de entrada actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPDATE_RECEIPT_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function updateReceiptError(errorMessage) {
    return dispatch => {
        // Create notification for update receipt error
        dispatch(addNotification({
            message: 'Error al actualizar el albaran de entrada',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPDATE_RECEIPT_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Upload receipt files
export function uploadReceiptFiles(receiptId, files) {
    return async (dispatch) => {
        try {
            dispatch(uploadReceiptFilesRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post(`/api/receipts/${receiptId}/files`, files, {
                headers: { 'Authorization': 'Bearer ' + token },
                onUploadProgress: function (e) {
                    dispatch(uploadReceiptFilesProgress(e.loaded / e.total))
                }
            });

            dispatch(utilsLib.response(res, uploadReceiptFilesSuccess, uploadReceiptFilesError));
        } catch (err) {
            dispatch(utilsLib.response(err, uploadReceiptFilesError));
        }
    };
}
function uploadReceiptFilesRequest() {
    return {
        type: UPLOAD_RECEIPT_FILES_REQUEST,
        isFetching: true
    };
}
function uploadReceiptFilesProgress(percent) {
    return {
        type: UPLOAD_RECEIPT_FILES_PROGRESS,
        percent
    };
}
function uploadReceiptFilesSuccess (payload) {
    return dispatch => {
        // Create notification for upload receipt file success
        dispatch(addNotification({
            message: 'Ficheros subidos correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPLOAD_RECEIPT_FILES_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function uploadReceiptFilesError(errorMessage) {
    return dispatch => {
        // Create notification for upload receipt file error
        dispatch(addNotification({
            message: 'Error al subir los ficheros',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPLOAD_RECEIPT_FILES_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Download receipt file
export function downloadReceiptFile(receiptId, fileId) {
    return async (dispatch) => {
        try {
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/receipts/${receiptId}/files/${fileId}`, {
                headers: { 'Authorization': 'Bearer ' + token },
                responseType: 'blob'
            });

            if( res.status === 200 ) {
                saveFile(res);
            }

        } catch (err) {
            dispatch(addNotification({
                message: 'Error al descargar el fichero',
                color: 'red',
                icon: 'warning-sign'
            }));
        }
    };
}

// Delete receipt file
export function deleteReceiptFile(receiptId, fileId) {
    return async (dispatch) => {
        try {
            dispatch(deleteReceiptFileRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/receipts/${receiptId}/files/${fileId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteReceiptFileSuccess, deleteReceiptFileError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteReceiptFileError));
        }
    };
}
function deleteReceiptFileRequest() {
    return {
        type: DELETE_RECEIPT_FILE_REQUEST,
        isFetching: true
    };
}
function deleteReceiptFileSuccess (payload) {
    return dispatch => {
        // Create notification for delete file success
        dispatch(addNotification({
            message: 'Fichero eliminado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_RECEIPT_FILE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function deleteReceiptFileError(errorMessage) {
    return dispatch => {
        // Create notification for delete file error
        dispatch(addNotification({
            message: 'Error al eliminar el fichero',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_RECEIPT_FILE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Delete receipt
export function deleteReceipt(receiptId) {

    return async (dispatch) => {
        try {
            dispatch(deleteReceiptRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/receipts/${receiptId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteReceiptSuccess, deleteReceiptError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteReceiptError));
        }
    };
}
function deleteReceiptRequest() {
    return {
        type: DELETE_RECEIPT_REQUEST,
        isFetching: true
    };
}
function deleteReceiptSuccess (payload) {
    return dispatch => {
        // Create notification for delete receipt success
        dispatch(addNotification({
            message: 'Albaran de entrada eliminado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_RECEIPT_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function deleteReceiptError(errorMessage) {
    return dispatch => {
        // Create notification for delete receipt error
        dispatch(addNotification({
            message: 'Error al eliminar el albaran de entrada',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_RECEIPT_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Clean receipts reducer
export function cleanReceipts() {
    return {
        type: 'CLEAN_RECEIPTS',
        isFetching: false,
        error: false,
        payload: []
    }
}



// WEBPACK FOOTER //
// ./src/actions/receipts.js